var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5SnapSwab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1 0h260v260H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13 185.858c-1.378 2.802-1.567 7.047-.983 10.708.583 3.661 1.111 4.497 2.673 7.557a70.65 70.65 0 0 0 4.497 7.878c.045.087.095.172.152.252.33.483.657.92.96 1.342 1.837 2.297 3.588 3.913 5.512 6.238.023.078.101.128.152.202a140.395 140.395 0 0 1 3.886 5.053l-.023 12.15h-22.05l1.039-25.334h.023l1.718-41.908 1.768-42.417.542-13.322a.919.919 0 0 1 .984-.896l20.951 1.043a.919.919 0 0 1 .891.983l-3.344 64.481a40.08 40.08 0 0 0-6.137-.1c-.78.027-1.617.077-2.476.178-.658.074-1.315.175-1.97.303-5.155.984-7.373 2.803-8.765 5.61Z",
    fill: "#CBE8EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.986 237.261h-13.24a46.795 46.795 0 0 1 1.838-9.748c1.567-4.952 1.493-15.26 1.493-15.26l1.236-.252 7.86-1.59s-.86 4.65-1.213 9.422c-.23 3.257-.23 6.592.46 8.54.881 2.53 1.336 6.137 1.566 8.888ZM169.982 113.775l7.193.358-1.382 46.065-4.796 2.89-3.064.725z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.276 195.436c-7.41-.652-9.592.873-15.692 2.508-6.1 1.636-15.903 5.774-23.75 5.338-7.845-.436-15.47-10.896-5.447-23.533s32.467-15.688 69.074-20.263c36.607-4.575 45.321 10.024 55.124 17.87C246.388 185.2 261 190.423 261 190.423v46.856h-75.62s-6.432-12.785-12.863-18.945c-6.43-6.16-11.718-15.953-12.352-21.769l-2.89-1.13Z",
    fill: "#A6795E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.177 131.442-1.617 48.353c-.568.015-1.134.065-1.695.151-.658.074-1.315.175-1.97.303-5.155.984-7.373 2.803-8.765 5.61-1.392 2.806-1.567 7.046-.983 10.707.583 3.661 1.111 4.497 2.673 7.557a75.101 75.101 0 0 0 4.649 8.13l-10.483-.326h-.023l1.741-41.908 1.746-42.417h10.974a3.758 3.758 0 0 1 3.753 3.84Z",
    fill: "#F0AD43",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.246 170.203-.363 9.743c-.658.074-1.315.175-1.97.303-5.154.984-7.373 2.803-8.765 5.61-1.392 2.806-1.566 7.046-.983 10.707.583 3.661 1.112 4.497 2.674 7.557a75.101 75.101 0 0 0 4.648 8.13l-10.482-.326h-.023l1.74-41.908 13.524.184Z",
    fill: "#272E4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 43.768 1.096 23h56.135s13.422 12.375 24.893 16.597c11.47 4.221 20.965 7.005 23.266 11.704 2.302 4.7-.574 17.943-8.268 17.654-7.694-.29-28.972-10.267-28.972-10.267L29.87 56.676l-14.7-6.142L1 43.768Z",
    fill: "#A6795E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.368 33.92c.978-2.298 1.01-4.843 1.029-7.35.684 2.755.983 5.663.211 8.383-.344 1.217-.919 2.37-1.314 3.564a16.702 16.702 0 0 0-.918 6.431 41.582 41.582 0 0 1-5.131.06 4.456 4.456 0 0 1-2.297-.556c-.919-.61-1.378-2.32-.58-3.215.635-.694 2.233-.919 3.07-1.378 2.494-1.342 4.79-3.266 5.93-5.94Z",
    fill: "#946951",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEC",
    fillRule: "nonzero",
    d: "m1.106 30.157 160.07 70.82 1.984-4.387L1.106 25.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 70.838.096-29.496s12.04 1.048 16.381 2.89c4.341 1.842 23.759 12.945 23.759 12.945S65.123 67.352 73.8 68.817c8.677 1.465 14.199 2.021 14.199 2.021s4.594 1.107 4.662 5.053c.07 3.946.262 10.68-11.842 12.628 0 0-2.168-.689-2.297.96-.128 1.65-1.286 8.397-6.683 9.978-5.398 1.58-11.742.831-11.37 2.843.372 2.012-.987 5.852-6.66 7.267-5.674 1.415-9.376 1.162-16.18-.46-6.802-1.62-15.158-6.968-16.784-8.364C19.218 99.346 1 70.838 1 70.838Z",
    fill: "#986F55",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.106 41.756a65.78 65.78 0 0 1 12.568 1.286c6.89 1.41 24.47 11.401 32.955 16.27 7.878 4.516 28.48 11.195 40.162 11.232a5.439 5.439 0 0 1 4.672 2.54c1.378 2.256 2.476 5.733.073 9.583-4.176 6.674-13.363 5.163-13.363 5.163",
    stroke: "#946951",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 49.772c1.286-.143 20.368 9.646 26.992 15.494 6.624 5.848 25.178 17.4 32.574 19.868C67.96 87.6 77.388 87.94 78.173 87.83c.786-.11 1.952 15.582-18.443 12.559",
    stroke: "#946951",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.399 101.946s8.599 6.932 19.513 8.296c10.915 1.365 20.617-3.031 16.827-9.853 0 0-14.576-1.948-25.022-8.93",
    stroke: "#946951",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 70.838s25.587-26.142 48.541-29.055c22.954-2.912 25.577 4.254 26.95 13.86 1.374 9.605-28.415 13.51-28.415 13.51L7.89 73.222 1 70.837Z",
    fill: "#946951",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 129.407s9.569-15.811 27.332-32.21c17.764-16.4 24.406-19.524 37.291-28.311 12.885-8.788 14.057-16.592 4.879-23.428-9.178-6.835-24.806-2.926-34.944 1.953C25.42 52.289 6.085 64.98 1 70.838v58.57Z",
    fill: "#A6795E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m168.815 81.748 1.571-21.37M173.372 82.69l3.459-8.012M178.241 86.461l15.086-14.139M182.012 91.33l7.543-3.298M183.9 96.517l20.58-2.518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.089 237.266c-9.293-4.93-24.3-12.683-29.124-15.665-6.89-4.217-11.291-12.352-14.475-18.691-3.183-6.34-9.527-12.862-16.394-17.989-6.868-5.126-14.456-5.466-22.587-3.004-8.13 2.462-6.362 14.65-6.362 14.65-5.104-15.357 10.937-20.489 22.05-16.951 11.111 3.537 18.374 13.238 26.83 21.525 8.457 8.287 9.698 11.645 18.867 21.168 6.43 6.67 19.752 12.228 27.102 14.957h-5.907Z",
    fill: "#966C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.028 201.141s5.645 3 14.998 3.533c9.352.533 12.173-.708 12.173-.708s-10.565 5.292-17.29 5.292c0 0 9.853 17.36 16.486 18.834 6.633 1.475 17.038 1.006 18.623 0 0 0-9.468 3.97-16.028 3.335l-15.379-10.515-8.999-10.772-4.584-8.999Z",
    fill: "#966C54",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#272E4E",
    strokeLinecap: "round",
    d: "m170.997 131.548-2.049 46.262"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5SnapSwab);
export default __webpack_public_path__ + "static/media/5-snap-swab.4b4fd0bd.svg";
export { ForwardRef as ReactComponent };